<template>
  <section class="export-topic">
    <div>When you think you're done annotating you data - just export it as csv to use further on.</div>
    <yn-button color="primary" @click.stop.prevent="download">Download CSV</yn-button>
  </section>
</template>

<script>
import Button from '@/components/common/Button';
import config from '@/config';

export default {
  components: {
    'yn-button': Button
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },

  methods: {
    download() {
      const token = localStorage.getItem('ALDABADA_AUTH_TOKEN', token);

      const url = config.apihostname+`/projects/${this.id}/tasks/csv?authToken=${token}`;
      window.open(url, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.export-topic {
  > div {
    margin-bottom: 1rem;
  }
}
</style>
